import React from 'react';

export default function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <section className="contact-us" id="contact">
            <div className="footer">
      <p>Copyright © {currentYear} Computer Study. All Rights Reserved. </p>
    </div>
        </section>
    );
}
